import { render, staticRenderFns } from "./privacy-statement.vue?vue&type=template&id=a6f983b2&scoped=true&lang=pug&"
import script from "./privacy-statement.vue?vue&type=script&lang=js&"
export * from "./privacy-statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f983b2",
  null
  
)

export default component.exports